import * as LgaStoreActions from './lga.actions';
import * as LgaStoreSelectors from './lga.selectors';
import * as LgaStoreReducer from './lga.reducer';

export { LgaStoreActions, LgaStoreSelectors, LgaStoreReducer };